<template>
	<div>
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2627">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2627)">
				<path
					id="path"
					d="M9.56 18.82C9.37 18.82 9.18 18.75 9.03 18.6L2.96 12.53C2.67 12.24 2.67 11.76 2.96 11.47L9.03 5.4C9.32 5.11 9.8 5.11 10.09 5.4C10.38 5.69 10.38 6.17 10.09 6.46L4.55 12L10.09 17.54C10.38 17.83 10.38 18.31 10.09 18.6C9.95 18.75 9.75 18.82 9.56 18.82L9.56 18.82Z"
					:fill="color"
					fill-opacity="1.000000"
					fill-rule="nonzero"
				/>
				<path
					id="path"
					d="M20.49 12.75L3.66 12.75C3.25 12.75 2.91 12.4 2.91 12C2.91 11.59 3.25 11.25 3.66 11.25L20.49 11.25C20.9 11.25 21.24 11.59 21.24 12C21.24 12.4 20.9 12.75 20.49 12.75L20.49 12.75Z"
					:fill="color"
					fill-opacity="1.000000"
					fill-rule="nonzero"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";

@Options({
	props: {
		color: { type: String, default: "#FFFFFF" },
	},
})
export default class IconArrowLeft extends Vue {}
</script>

<style scoped lang="scss"></style>
